<!-- @format -->
<template>
  <div class="template-persona-edit">
    <el-container class="main-container">
      <el-header style="padding: 0">
        <div class="header-bar">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/uxm/templateProject' }">模板项目管理</el-breadcrumb-item>
            <el-breadcrumb-item>{{ projectName }}</el-breadcrumb-item>
            <el-breadcrumb-item>编辑画像</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-header>
      <el-container class="content-container">
        <el-main class="el-main">
          <div class="persona-edit-wrapper">
            <!-- 这里需要嵌入用户端的画像编辑组件 -->
            <!-- 由于管理端和用户端是分离的项目，这里使用iframe嵌入用户端的编辑页面 -->
            <iframe
              :src="editUrl"
              frameborder="0"
              style="width: 100%; height: calc(100vh - 100px);"
              @load="handleIframeLoad"
            ></iframe>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'TemplatePersonaEdit',
  data() {
    return {
      templatePersonaId: null,
      templateProjectId: null,
      projectName: '',
      editUrl: ''
    }
  },
  created() {
    // 从路由参数获取信息
    // 【重要】确保ID正确转换为字符串，避免BigNumber精度丢失
    this.templatePersonaId = this.$route.params.personaId ? String(this.$route.params.personaId) : null
    this.templateProjectId = this.$route.query.templateProjectId ? String(this.$route.query.templateProjectId) : null
    this.projectName = decodeURIComponent(this.$route.query.projectName || '')
    
    if (!this.templatePersonaId) {
      console.error('模板画像ID不存在，无法编辑')
      this.$message.error('模板画像ID不存在，无法编辑')
      return
    }
    
    // 获取管理端token，传递给用户端页面（实现免登录）
    const adminToken = localStorage.getItem('token') || ''
    
    // 构建用户端编辑页面URL（需要传递模板项目标识和管理端token）
    // 注意：这里需要用户端的编辑页面支持模板项目编辑和管理端token
    const userFrontendBaseUrl = 'http://localhost:8080' // 用户端前端地址
    const tokenParam = adminToken ? `&adminToken=${encodeURIComponent(adminToken)}` : ''
    // 【重要】确保ID以字符串形式传递，避免精度丢失
    this.editUrl = `${userFrontendBaseUrl}/persona/${this.templatePersonaId}/${encodeURIComponent(this.projectName)}?isTemplate=true&templateProjectId=${this.templateProjectId}${tokenParam}`
    
    console.log('构建编辑页面URL:', {
      templatePersonaId: this.templatePersonaId,
      templateProjectId: this.templateProjectId,
      projectName: this.projectName,
      editUrl: this.editUrl
    })
  },
  methods: {
    handleIframeLoad() {
      console.log('画像编辑页面加载完成')
    }
  }
}
</script>

<style scoped>
.template-persona-edit {
  width: 100%;
  height: 100vh;
}

.main-container {
  height: 100%;
}

.header-bar {
  padding: 15px 20px;
  background: #fff;
  border-bottom: 1px solid #e4e7ed;
}

.content-container {
  height: calc(100% - 60px);
}

.el-main {
  padding: 0;
  height: 100%;
}

.persona-edit-wrapper {
  width: 100%;
  height: 100%;
}
</style>


